import { sha256 } from 'js-sha256'
import { useEffect } from 'react'
import OpenApp from "react-open-app";
import { useRouter } from "next/router";
import { encryptAES } from '@helper/util/useEncrypt'
import Link from 'pages/link';

type ProductType = {
  // productId :string;
  // nationCode :number;
}
type PropsType = {
  share : ProductType
}

// const nationCode = process.env.NEXT_PUBLIC_NATION_CODE;
const API_KEY_USERNAME = 'mobile'
const API_KEY_PASSWORD = 'a4786851f5261822f0f57182ee2dc656b57687c8a105c1b697c280ef48aee7e8'

if (typeof window !== "undefined") {
  var check_url = window.location.origin;
  var check_url_query = window.location.pathname;
  var get_nation_code = check_url_query.split("/");
  var nation_code = get_nation_code[3]
  
  // if(check_url === "https://dev.sellon.net") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://staging-id-cms.sellon.net/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://dev2-cms-sgmaster.sellon.net/';
  //   }
  // } else if(check_url === "https://dev.sellon.store") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://staging-id-cms.sellon.store/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://dev2-cms-sgmaster.sellon.store/';
  //   }
  // } else if(check_url === "https://sellon.net") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://cms-idmaster.sellon.net/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://cms-sgmaster.sellon.net/';
  //   }
  // } else if(check_url === "https://sellon.store") {
  //   if(nation_code === "62") {
  //     var cms_url = 'https://cms-idmaster.sellon.store/';
  //   } else if(nation_code === "65") {
  //     var cms_url = 'https://cms-sgmaster.sellon.store/';
  //   }
  // }
  if(check_url === "https://dev.sellon.net") {
      var cms_url_id = 'https://staging-id-cms.sellon.net/';
      var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
  } else if(check_url === "https://dev.sellon.store") {
      var cms_url_id = 'https://staging-id-cms.sellon.store/';
      var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.store/';
  } else if(check_url === "https://sellon.net") {
      var cms_url_id = 'https://cms-idmaster.sellon.net/';
      var cms_url_sg = 'https://cms-sgmaster.sellon.net/';
  } else if(check_url === "https://sellon.store") {
    var cms_url_id = 'https://cms-idmaster.sellon.store/';
    var cms_url_sg = 'https://cms-sgmaster.sellon.store/';
  } else { // because localhost
    var cms_url_id = 'https://staging-id-cms.sellon.net/';
    var cms_url_sg = 'https://dev2-cms-sgmaster.sellon.net/';
  }
}

export default function ShareSellon ({ buserid, share }) {

    // for ios
    var router = useRouter();
    // var sellon = "https://sellon.net";
    var sellon = check_url;
    var globalroute = sellon + router.asPath
    var withoutsellon = router.asPath
    // console.log(withoutsellon)

    const splitUrl =  globalroute.split("/");
    const referral_code = splitUrl[4];

    const nationCode = splitUrl[5];
    // console.log(nationCode);

    const isIphone = (/iphone|ipod/).test(navigator.userAgent.toLowerCase())
    const isAndroid = (/android/).test(navigator.userAgent.toLowerCase())

    const callApiMobileRegistActivity = async () => {
      // const apiUrl = `${nationCode==='65' ? process.env.NEXT_PUBLIC_CMS_URL : process.env.NEXT_PUBLIC_CMS_URL_ID}api_mobile/apikey/auth/?nation_code=${nationCode}`
      const apiUrl = `${nationCode==='65' ? cms_url_sg : cms_url_id}api_mobile/apikey/auth/?nation_code=${nationCode}`
      const details = {
        username: API_KEY_USERNAME,
        password: API_KEY_PASSWORD,
        type: 'click_link',
        referral: withoutsellon
      }
      // let formBody = ['type=click_link', `referral=${withoutsellon}`]
      let formBody = []
      for (const property in details) {
        const encodedKey = encodeURIComponent(property)
        const encodedValue = encodeURIComponent(details[property])
        formBody.push(encodedKey + '=' + encodedValue)
      }
      formBody = formBody.join('&')

      // const apikey = await fetch(apiUrl, {
      //   body: formBody,
      //   headers: {
      //     // 'Content-Type': 'application/form-data',
      //     'Content-Type': 'application/x-www-form-urlencoded',
      //     // 'Accept' : 'application/json',
      //   },
      //   method: 'POST'
      // }).then(response => response.json())
      // const { apikey_plain } = await apikey.data
      // const shareUrl = `${nationCode==='65' ? process.env.NEXT_PUBLIC_CMS_URL : process.env.NEXT_PUBLIC_CMS_URL_ID}api_mobile/mobile_registration_activity/`
      const shareUrl = `${nationCode==='65' ? cms_url_sg : cms_url_id}api_mobile/mobile_registration_activity/`
      const shareData = await fetch(shareUrl, {
        body: formBody,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST'
      }).then(response => response.json())
      // console.log(shareData)
      // console.log(formBody)

      // console.log(shareUrl)
    }
 
    const detectDevice = () => {
      // const isIphone = (/iphone|ipod/).test(navigator.userAgent.toLowerCase())
      // const isAndroid = (/android/).test(navigator.userAgent.toLowerCase())
      
      // var isMobile = (/iphone|ipod|android|ie|blackberry|fennec/).test(navigator.userAgent.toLowerCase());
      if (!isIphone) {
        // window.location = 'https://apps.apple.com/id/app/sellon-online-marketplace/id1462394563'
        // redirectTo()
        
        window.location = 'https://play.google.com/store/apps/details?id=com.csi.sellon&referrer=' + globalroute  // don't forget change to this before push
      } 
      // window.location = `http://localhost:3000/${nationCode==='62'?"id":"en-SG"}/buyandsell/${product.id}`;
    }

  //   // redirect to landing with query -> move to new route '/link'
  //   const redirectTo = () => {
  //     router.push({
  //         pathname: "/link",
  //         query: { 
  //         name: encodeURIComponent(encryptAES(globalroute)),
  //         q1: encodeURIComponent(encryptAES("empty")),
  //         q2: encodeURIComponent(encryptAES("empty")),
  //         q3: encodeURIComponent(encryptAES("empty"))
  //         }
  //     });
  //   } 

  useEffect(() => {

    callApiMobileRegistActivity()
    detectDevice()

    return () => {
    }
  }, [])

  if(isIphone) {
      return (
        // <div className="w-screen h-screen flex items-center justify-center">Content will be redirected into SellOn Apps!</div>
        <Link linkurl={globalroute}></Link>
      )
  } else {
    return(
      <div className="w-screen h-screen flex items-center justify-center">Content will be redirected into SellOn Apps!</div>
    )
  }

  // return (
  //     // <div className="w-screen h-screen flex items-center justify-center">Content will be redirected into SellOn Apps!</div>
  //     <Link linkurl={globalroute}></Link>
  // )
}

export async function getShareSellon (product) {
  const { nationCode , productId } = product;
  // const apiUrl = `${process.env.NEXT_PUBLIC_CMS_URL}api_mobile/apikey/auth/?nation_code=${nationCode}`
  const apiUrl = `${nationCode==='65' ? process.env.NEXT_PUBLIC_CMS_URL : process.env.NEXT_PUBLIC_CMS_URL_ID}api_mobile/apikey/auth/?nation_code=${nationCode}`
  const details = {
    username: API_KEY_USERNAME,
    password: API_KEY_PASSWORD
  }
  let formBody = []
  for (const property in details) {
    const encodedKey = encodeURIComponent(property)
    const encodedValue = encodeURIComponent(details[property])
    formBody.push(encodedKey + '=' + encodedValue)
  }
  formBody = formBody.join('&')

  const apikey = await fetch(apiUrl, {
    body: formBody,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  }).then(response => response.json())
  const { apikey_plain } = apikey.data
  const shareUrl = `${nationCode==='65' ? process.env.NEXT_PUBLIC_CMS_URL : process.env.NEXT_PUBLIC_CMS_URL_ID}api_mobile/seller/detail/index/?apikey=${sha256(apikey_plain)}&nation_code=${nationCode}`
  const shareData = await fetch(shareUrl).then(response => response.json())
  return shareData.data.seller
}

export async function getServerSideProps ({ params }) {
  // const { nationCode } = params
  const share = await getShareSellon({ })
  return {
    props: {
      share,
      // nationCode,
    }
  }
}